import { Component } from '@angular/core';

@Component({
    selector: 'empty-page',
    template: '',
})
export class EmptyPageComponent {}
